import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardBody, Row, Col } from 'reactstrap';
import {ArraySelect} from "@pages/components/InputSelect";
import InputCustom from "@pages/components/InputCustom";
import {ButtonContainer, LoaderContainer, override} from "@pages/reusable-components/styled-components";
import {ClipLoader} from "react-spinners";

export default function Company({
                                               initialCustomer,
                                               errors,
                                               businessTypes,
                                               companyTypes,
                                               goList,
                                               onSave,
                                           }) {
    const allowedFields = [
        'business_activity_id',
        'business_address',
        'business_phone_number',
        'company_type_id',
        'company_name',
        'insurance_company',
        'insurance_excess',
        'company',
    ];
    const [loading, setLoading] = useState(true);
    const [customer, setCustomer] = useState({});

    useEffect(() => {
        if (initialCustomer) {
            const filtered = Object.fromEntries(
                allowedFields.map((key) => [key, initialCustomer[key] ?? ''])
            );
            filtered.company = initialCustomer.company ?? {};
            setCustomer(filtered);
            setLoading(false)
        }
    }, [initialCustomer]);

    const getValue = (key) => customer?.[key] ?? '';
    const getCompanyValue = (key) => customer?.company?.[key] ?? '';

    const update = (updates) => {
        setCustomer((prev) => ({
            ...prev,
            ...updates,
        }));
    };
    const updateCompany = (key, value) => {
        setCustomer(prev => {
            const updatedCompany = {
                ...prev.company,
                [key]: value
            };

            return {
                ...prev,
                company: updatedCompany,
                [`company_${key}`]: value,
            };
        });
    };
    const handleSave = () => {
        onSave(customer);
    };
    return (
        loading ? <LoaderContainer>
                <ClipLoader
                    css={override}
                    size={40}
                    color={`#7B61E4`}
                    loading={loading}
                />
            </LoaderContainer>
            :
        <Card>
            <CardHeader>
                <h1 className="mb-0">Company Information</h1>
            </CardHeader>
            <CardBody>
                <Row>
                    <Col md={4} sm={12}>
                        <ArraySelect
                            label="Business type"
                            options={businessTypes}
                            value={
                                getValue('business_activity_id') || getCompanyValue('business_activity_id')
                            }
                            onChange={(e) => update({'business_activity_id': e.target.value})}
                            invalid={!!errors?.business_activity_id}
                            defaultOption
                            valueKey="id"
                            labelKey="name"
                            errorMessage="Please provide a business type."
                        />

                        <InputCustom
                            newLabel="Business address"
                            placeholder="Business address"
                            value={getCompanyValue('address')}
                            onChange={(e) => updateCompany('address', e.target.value)}
                            invalid={!!errors?.business_address}
                            errorMessage="Please provide a business address."
                        />

                        <InputCustom
                            newLabel="Business phone number"
                            placeholder="Business phone number"
                            value={getCompanyValue('phone_number')}
                            onChange={(e) => updateCompany('phone_number', e.target.value)}
                            invalid={!!errors?.business_phone_number}
                            errorMessage="Please provide a business phone number."
                        />
                    </Col>

                    <Col md={4} sm={12}>
                        <ArraySelect
                            label="Company type"
                            options={companyTypes}
                            value={
                                getValue('company_type_id') || getCompanyValue('company_type_id')
                            }
                            onChange={(e) => update({'company_type_id': e.target.value})}
                            defaultOption
                            valueKey="id"
                            labelKey="name"
                            invalid={!!errors?.company_type_id}
                            errorMessage="Please provide a company type."
                        />

                        <InputCustom
                            newLabel="Company name"
                            required
                            checkValid={false}
                            placeholder="Company name"
                            value={getCompanyValue('name')}
                            onChange={(e) => updateCompany('name', e.target.value)}
                            invalid={!!errors?.company_name}
                            errorMessage="Please provide a company name."
                        />
                    </Col>

                    <Col md={4} sm={12}>
                        <InputCustom
                            newLabel="Insurance Company"
                            placeholder="Insurance Company"
                            value={getValue('insurance_company')}
                            onChange={(e) => update({'insurance_company': e.target.value})}
                            invalid={!!errors?.insurance_company}
                            errorMessage="Please provide a Insurance company."
                        />

                        <InputCustom
                            newLabel="Insurance Excess"
                            placeholder="Insurance Excess"
                            value={getValue('insurance_excess')}
                            onChange={(e) => update({'insurance_excess': e.target.value})}
                        />
                    </Col>
                </Row>
                <div className="d-flex flex-row justify-content-end">
                    <ButtonContainer onClick={() => goList(true)}>Cancel</ButtonContainer>
                    <ButtonContainer reverse onClick={() => handleSave()}>Save</ButtonContainer>
                </div>
            </CardBody>
        </Card>
    );
}
